import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4507e532&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=4507e532&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=4507e532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4507e532",
  null
  
)

export default component.exports